import {
  ModuleIOValueTypeEnum,
  ModuleInputKeyEnum,
  ModuleOutputKeyEnum,
  ModuleTemplateTypeEnum,
} from '../../constants';
import {
  FlowNodeInputTypeEnum,
  FlowNodeOutputTypeEnum,
  FlowNodeTypeEnum,
} from '../../node/constants';
import { FlowModuleTemplateType } from '../../types';
import { Input_Template_Switch } from '../input';
import { Output_Template_Finish } from '../output';

export const CreateGroupModule: FlowModuleTemplateType = {
  id: 'ContentEditModule',
  templateType: ModuleTemplateTypeEnum.tools,
  flowType: FlowNodeTypeEnum.pullGroup,
  name: '拉群',
  inputs: [
    Input_Template_Switch,
    {
      label: '拉群类型',
      valueType: ModuleIOValueTypeEnum.string,
      type: FlowNodeInputTypeEnum.select,
      key: 'pullGroupMode',
      required: true,
      list: [
        { label: '新建群', value: 1 },
        { label: '拉入已有群', value: 2 },
      ],
      value: '新建群',
    },
    {
      label: '群名称',
      valueType: ModuleIOValueTypeEnum.string,
      type: FlowNodeInputTypeEnum.custom,
      key: 'groupName',
      showTargetInApp: false,
      showTargetInPlugin: false,
    },
    {
      label: '除对话用户外的群成员',
      type: FlowNodeInputTypeEnum.custom,
      valueType: ModuleIOValueTypeEnum.any,
      showTargetInApp: false,
      key: 'otherUserIds',
      required: true,
      hideInApp: true,
      hideInPlugin: true,
    },
    {
      label: '目标群',
      type: FlowNodeInputTypeEnum.custom,
      valueType: ModuleIOValueTypeEnum.any,
      showTargetInApp: false,
      key: 'targetGroupIds',
      required: true,
      hideInApp: true,
      hideInPlugin: true,
    },
    {
      label: '自定义参数',
      valueType: ModuleIOValueTypeEnum.string,
      type: FlowNodeInputTypeEnum.addInputParam,
      key: ModuleInputKeyEnum.addTemplate,
      edit: false,
      editField: {
        dataType: true,
        key: true,
        required: true,
      },
      defaultEditFieldValue: {
        valueType: 'string',
        required: true,
      },
      showTargetInApp: false,
      showTargetInPlugin: false,
    },
  ],
  outputs: [
    Output_Template_Finish,
    {
      key: ModuleOutputKeyEnum.contentEditResult,
      targets: [],
      valueType: ModuleIOValueTypeEnum.string,
      description: '经过加工后的文本',
      label: '加工后文本',
      type: FlowNodeOutputTypeEnum.source,
    },
  ],
};
